module.exports = __webpack_public_path__ + "static/img/logo_name.623c7d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/logo_name.png
// module id = Fw7W
// module chunks = 41